<div class="dialog-header">
  <h2 mat-dialog-title>{{ dialogTypeTitle[data.type] }}</h2>
</div>
<mat-dialog-content class="mat-dialog-content centered">
  <div class="alert-text"> {{ data.message }} </div>
</mat-dialog-content>
<div mat-dialog-actions class="action-btns">
  <button mat-dialog-close class="btn primary">Ok</button>
</div>
